import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";
import CustomButton from "../pages/CustomButton";
const DesignationManager = () => {
  const [designations, setDesignations] = useState([]);
  const [managersForRole, setManagersForRole] = useState([]); 
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [editingId, setEditingId] = useState(null);
  const [draft, setDraft] = useState({});

  const [isAddOpen, setAddOpen] = useState(false);
  const [newDesignation, setNewDesignation] = useState({
    name: "",
    short_code: "",
    level: 0,
  });

  useEffect(() => {
    fetchDesignations();
  }, []);

  const fetchDesignations = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/api/designations/`, {
        headers: getAuthHeaders(),
      });
      setDesignations(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Failed to load designations", err);
      alert("Failed to load designations");
    } finally {
      setLoading(false);
    }
  };

  const fetchManagersByDesignation = async (designation) => {
    try {
      if (!designation) return [];
      const res = await axios.get(`${BASE_URL}/api/managers-by-designation/`, {
        headers: getAuthHeaders(),
        params: { designation },
      });
      const data = Array.isArray(res.data) ? res.data : [];
      const normalized = data
        .map((it, idx) => {
          const id =
            it.id ?? it.manager_id ?? it.user_id ?? `${designation}-${idx}`;
          const name =
            it.name ?? it.manager_name ?? it.full_name ?? it.username ?? "";
          return id ? { id, name } : null;
        })
        .filter(Boolean);
      return normalized;
    } catch (err) {
      console.warn(
        "Failed to fetch managers for designation:",
        designation,
        err
      );
      return [];
    }
  };

  const startEdit = async (item) => {
    setEditingId(item.id);
    const designationKey = (item.name ?? item.short_code ?? "").toString();
    const managers = await fetchManagersByDesignation(designationKey);
    setManagersForRole(managers);

    // try match existing role to fetched managers
    const matchedRoleId =
      item.role_id ??
      item.role?.id ??
      (
        managers.find(
          (m) =>
            (m.name || "").toLowerCase() ===
            (item.role || item.role_name || "").toLowerCase()
        ) || {}
      ).id ??
      "";

    setDraft({
      name: item.name ?? "",
      short_code: item.short_code ?? item.shortCode ?? "",
      level: item.level ?? 0,
      role_id: matchedRoleId,
    });
  };

  const cancelEdit = () => {
    setEditingId(null);
    setDraft({});
    setManagersForRole([]);
  };

  const onDraftChange = (key, value) => {
    setDraft((d) => ({ ...d, [key]: value }));
  };


  const updateDesignation = async (id) => {
    if (!draft.name?.trim()) {
      alert("Please enter designation name");
      return;
    }
    setSaving(true);
    try {
      const payload = {
        name: draft.name.trim(),
        short_code: draft.short_code?.trim() ?? "",
        level: Number(draft.level) || 0,
        role_id: draft.role_id || null,
      };

      const res = await axios.put(
        `${BASE_URL}/api/designations/${id}`,
        payload,
        {
          headers: getAuthHeaders(),
        }
      );

      if (res.status === 200 || res.status === 204) {
        await fetchDesignations();
        cancelEdit();
      } else {
        console.warn("Unexpected update", res);
        alert("Failed to update designation");
      }
    } catch (err) {
      console.error("Update failed", err);
      alert("Failed to update designation");
    } finally {
      setSaving(false);
    }
  };

  const createDesignation = async (e) => {
    e?.preventDefault?.();
    if (!newDesignation.name.trim()) {
      alert("Please enter designation name");
      return;
    }
    setSaving(true);
    try {
      const payload = {
        name: newDesignation.name.trim(),
        short_code: newDesignation.short_code?.trim() ?? "",
        level: Number(newDesignation.level) || 0,
        role_id: newDesignation.role_id || null,
      };

      const res = await axios.post(`${BASE_URL}/api/designations`, payload, {
        headers: getAuthHeaders(),
      });

      if (res.status === 201 || res.status === 200) {
        setNewDesignation({ name: "", short_code: "", level: 0, role_id: "" });
        setAddOpen(false);
        await fetchDesignations();
      } else {
        console.warn("Unexpected create", res);
        alert("Failed to add designation");
      }
    } catch (err) {
      console.error("Create failed", err);
      alert("Failed to add designation");
    } finally {
      setSaving(false);
    }
  };


  const deleteDesignation = async (id) => {
    if (!window.confirm("Are you sure you want to delete this designation?"))
      return;
    setSaving(true);
    try {
      const res = await axios.delete(`${BASE_URL}/api/designations/${id}`, {
        headers: getAuthHeaders(),
      });
      if (res.status === 200 || res.status === 204) {
        await fetchDesignations();
      } else {
        console.warn("Unexpected delete", res);
        alert("Failed to delete designation");
      }
    } catch (err) {
      console.error("Delete failed", err);
      alert("Failed to delete designation");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="p-2 border border-gray-200">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-xl font-bold">
          <span className="text-blue-700"> Designation </span>
          <span className="text-blue-500">Management</span>
        </h1>

        <button
          className="bg-blue-500 text-white px-3 py-2 rounded"
          onClick={() => setAddOpen(true)}
        >
          Add Designation
        </button>
      </div>

          <div className="border rounded shadow  table-wrapper">
        <table className="unlock-dcr-leave-table text-sm ">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="p-2 border">S.No</th>
              <th className="p-2 border">Designation</th>
              <th className="p-2 border">Short Code ( Visible To Employee )</th>
              <th className="p-2 border">Level</th>
              <th className="p-2 border">Role</th>
              <th className="p-2 border">Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6" className="p-4 text-center">
                  Loading...
                </td>
              </tr>
            ) : designations.length === 0 ? (
              <tr>
                <td colSpan="6" className="p-4 text-center">
                  No designations found
                </td>
              </tr>
            ) : (
              designations.map((item, idx) => {
                const editing = editingId === item.id;
                return (
                  <tr
                    key={item.id ?? idx}
                    className={editing ? "bg-green-50" : ""}
                  >
                    <td className="p-2 border text-center">{idx + 1}</td>

                    <td className="p-2 border">
                      {editing ? (
                        <input
                          type="text"
                          value={draft.name}
                          onChange={(e) =>
                            onDraftChange("name", e.target.value)
                          }
                          className="w-full border px-2 py-1"
                        />
                      ) : (
                        item.name
                      )}
                    </td>

                    <td className="p-2 border">
                      {editing ? (
                        <input
                          type="text"
                          value={draft.short_code}
                          onChange={(e) =>
                            onDraftChange("short_code", e.target.value)
                          }
                          className="w-full border px-2 py-1"
                        />
                      ) : (
                        item.short_code ?? item.shortCode ?? ""
                      )}
                    </td>

                    <td className="p-2 border text-center">
                      {editing ? (
                        <input
                          type="number"
                          value={draft.level}
                          onChange={(e) =>
                            onDraftChange("level", Number(e.target.value))
                          }
                          className="w-24 border px-2 py-1 text-center"
                        />
                      ) : (
                        item.level ?? 0
                      )}
                    </td>

                    <td className="p-2 border text-center">
                      {editing ? (
                        <select
                          value={draft.role_id}
                          onChange={(e) =>
                            onDraftChange("role_id", e.target.value)
                          }
                          className="border px-2 py-1 w-full"
                        >
                          <option value="">
                            -- Select Manager (by designation) --
                          </option>
                          {managersForRole.map((r) => (
                            <option key={r.id} value={r.id}>
                              {r.name}
                            </option>
                          ))}
                        </select>
                      ) : (
                        item.role?.name ?? item.role_name ?? ""
                      )}
                    </td>

                    <td className="p-2 border text-center">
                      {editing ? (
                        <>
                          <CustomButton
                            onClick={() => updateDesignation(item.id)}
                            disabled={saving}
                            variant="save"
                            className="mr-2"
                          >
                            {saving ? "Updating" : "Update"}
                          </CustomButton>
                          <CustomButton onClick={cancelEdit} variant="cancel">
                            Cancel
                          </CustomButton>
                        </>
                      ) : (
                        <>
                          <CustomButton
                            onClick={() => startEdit(item)}
                            variant="edit"
                            className="mr-2"
                          >
                            Edit
                          </CustomButton>
                          <CustomButton
                            onClick={() => deleteDesignation(item.id)}
                            variant="cancel"
                          >
                            Delete
                          </CustomButton>
                        </>
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

  
      {isAddOpen && (
        <div className="fixed inset-0 z-50 flex items-start justify-center p-6">
          <div
            className="absolute inset-0 bg-black opacity-40"
            onClick={() => setAddOpen(false)}
          />
          <div className="relative bg-white rounded shadow-lg w-full max-w-2xl z-10 p-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-semibold">Add Designation</h2>
              <CustomButton onClick={() => setAddOpen(false)} variant="cancel">
                Close
              </CustomButton>
            </div>

            <form onSubmit={createDesignation} className="grid gap-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium">
                    Designation
                  </label>
                  <input
                    type="text"
                    value={newDesignation.name}
                    onChange={(e) =>
                      setNewDesignation((s) => ({ ...s, name: e.target.value }))
                    }
                    required
                    className="mt-1 block w-full border px-2 py-1"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium">
                    Short Code
                  </label>
                  <input
                    type="text"
                    value={newDesignation.short_code}
                    onChange={(e) =>
                      setNewDesignation((s) => ({
                        ...s,
                        short_code: e.target.value,
                      }))
                    }
                    className="mt-1 block w-full border px-2 py-1"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium">Level</label>
                  <input
                    type="number"
                    value={newDesignation.level}
                    onChange={(e) =>
                      setNewDesignation((s) => ({
                        ...s,
                        level: Number(e.target.value),
                      }))
                    }
                    className="mt-1 block w-full border px-2 py-1"
                  />
                </div>
              </div>

              <div className="flex justify-end gap-3 mt-4">
                <CustomButton type="submit" variant="print" disabled={saving}>
                  {saving ? "Submitting..." : "Submit"}
                </CustomButton>
                <CustomButton
                  onClick={() => {
                    setAddOpen(false);
                    setNewDesignation({
                      name: "",
                      short_code: "",
                      level: 0,
                      role_id: "",
                    });
                  }}
                  variant="cancel"
                >
                  Cancel
                </CustomButton>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default DesignationManager;
